import styles from './ContentBlock.module.scss'

export default function ContentBlock(props) {
  const { subheading, heading, description } = props.fields

  const rootClass = props.variant === 'centered' ? `${styles.content} ${styles.centered}` : styles.content
  const level = Math.min(6, Math.max(1, Math.round(Number(props.headingLevel)) || 3))
  const Heading = `h${level}`

  return (
    <div className={rootClass}>
      <div data-aos="fade-up">
        <p className={styles.subheading}>{subheading}</p>
        <Heading className={styles.heading}>{heading}</Heading>
        <div
          className={styles.WYSIWYG}
          dangerouslySetInnerHTML={{
            __html: description
          }}
        ></div>
      </div>
    </div>
  )
}
